import { VistaprintAuth } from '@vp/auth-react';
import { currentCulture } from 'src/utils/cultureUtil';
import { isDevelopmentMode } from 'src/utils/tenantUtil';

const DEV_CLIENT_ID = 'EnDiBkIYiGOo8mCkggqwdC9RApLweO1L'; // Design Services Static Site Dev Client
const CARE_CLIENT_ID = 'tCZE1T00Yk6Uqs4jLO0HtpwLopz8BN7F'; // VP CARE Console

interface AuthInitOptions {
  culture: string;
  options?: {
    connection?: string;
    redirectAfterSignOutCallback?: () => void;
    requireSession?: boolean;
  };
  developmentMode: boolean | { clientID: string; redirectUriOrigin?: string };
}

/**
 * Set up auth
 * @param isCareAgent lets the care agent login using AD
 */
async function initialize(isCareAgent = false, culture?: string) {
  const params: AuthInitOptions = {
    culture: culture || currentCulture,
    developmentMode: isDevelopmentMode() && { clientID: DEV_CLIENT_ID },
    options: { requireSession: true },
  };

  if (isCareAgent) {
    const org = new URLSearchParams(window.location.search).get('org');
    params.options = {
      ...params.options,
      connection: org || 'vistaprintcom-waad',
    };
    params.developmentMode = { clientID: CARE_CLIENT_ID };

    if (typeof window !== 'undefined' && !isDevelopmentMode()) {
      params.developmentMode.redirectUriOrigin = `${window.location.origin}/auth-callback/`;
    }
  }

  return VistaprintAuth.init(params);
}

export const authUtil = {
  initialize,
};
